import { render, staticRenderFns } from "./bannersetup.vue?vue&type=template&id=66d046d0&scoped=true&"
import script from "./bannersetup.vue?vue&type=script&lang=js&"
export * from "./bannersetup.vue?vue&type=script&lang=js&"
import style0 from "./bannersetup.vue?vue&type=style&index=0&id=66d046d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d046d0",
  null
  
)

export default component.exports